import { post } from '../client';

const BRAVO_MAIL_TO_SALE_URL =
  'https://bravowebsite-mail-validate.azurewebsites.net/api/HttpTrigger1?code=Vogm730Xxd/TB6b79p1Qaz1J4wstbjZy385XcHdU12muTAaXvzedYg==';

export default (data) => {
  return post(BRAVO_MAIL_TO_SALE_URL, data);
};
